/**
 * Versículos de arranque ETIQUETADOS con números Strong (concordancia OFFLINE).
 *
 * El texto KJV base vive en `kjv-seed.ts`. Aquí sustituimos el texto de un
 * subconjunto de versículos por la MISMA cadena KJV pero intercalando la marca
 * Strong inmediatamente después de la palabra correspondiente, con la sintaxis
 * que entiende `@/utils/verse-text` (`formatVerseText`):
 *   - `<WH####>` para hebreo (Antiguo Testamento)
 *   - `<WG####>` para griego (Nuevo Testamento)
 *
 * Cuando los números Strong están ocultos, `formatVerseText` elimina la marca y
 * el texto se ve idéntico al KJV; cuando están visibles, cada palabra etiquetada
 * se vuelve interactiva y abre su entrada del léxico (ver `strong-lexicon.ts`).
 *
 * La clave es la coordenada `book-chapter-verse` (mismos ids que `kjv-seed.ts`:
 * Génesis = 1, Juan = 43).
 *
 * NOTA: al etiquetar un versículo, su texto se renderiza partido en spans (palabra
 * + número Strong), por lo que deja de coincidir como cadena única. Por eso NO se
 * etiquetan los versículos sobre los que la suite `reader.spec.ts` asierta texto
 * completo (Génesis 1:1, Génesis 2:1, Juan 3:16): se eligen versículos vecinos
 * (Génesis 1:3 → hebreo, Juan 1:1 → griego) que cubren AT y NT sin romper esa suite.
 *
 * Este módulo es DATA (texto bíblico + marcas de dominio público), no cadenas de UI.
 */

/** Mapa coordenada (`book-chapter-verse`) → texto KJV con marcas Strong. */
export const STRONG_TAGGED_VERSES: Record<string, string> = {
  // Génesis 1:3 — Antiguo Testamento (hebreo).
  "1-1-3": "And God<WH430> said<WH559>, Let there be light<WH216>: and there was light<WH216>.",
  // Juan 1:1 — apertura del Nuevo Testamento (griego).
  "43-1-1":
    "In the beginning<WG746> was the Word<WG3056>, and the Word<WG3056> was with God<WG2316>, and the Word<WG3056> was God<WG2316>.",
};
